import React, { useEffect, useState } from 'react'
import Image from 'next/image'

import Overflow from 'react-overflow-indicator'

import { useField } from 'formik'

import RightArrow from 'public/icons/rightarrow.svg'
import ChevronRight from 'public/icons/chevron.svg'
import ChevronLeft from 'public/icons/chevron-left.svg'
import Checkmark from 'public/icons/checkmark.svg'

import Heading from 'components/Heading'
import Button from 'components/Button'

import styles from '../Signup.module.css'

const ChooseProfileBg = ({ setValue, watch, handleSubmit, formField, isSubmitting }) => {
  const { heroImage } = formField

  const value = watch(heroImage.name)
  const [cover, setCover] = useState(value)

  const [canScrollLeft, setCanScrollLeft] = useState(false)
  const [canScrollRight, setCanScrollRight] = useState(false)
  const [canScrollUp, setCanScrollUp] = useState(false)
  const [canScrollDown, setCanScrollDown] = useState(false)

  const covers = [
    'cad1.jpg',
    'cad2.jpg',
    'cad3.jpg',
    'cam1.jpg',
    'cam2.jpg',
    'cam3.jpg',
    'cnc1.jpg',
    // 'cnc2.jpg',
    'cnc3.jpg',
    'cnc4.jpg',
    'cnc5.jpg',
    'cnc6.jpg',
    'space1.jpg',
    'space2.jpg',
    'space3.jpg',
    'space4.jpg',
  ]

  const setCoverAndSubmit = () => {
    setValue(heroImage.name, cover)
    submit()
  }

  function submit() {
    setValue('step', 'cover')
    handleSubmit()
  }

  function scrollStateChange(state) {
    setCanScrollLeft(state.canScroll.left)
    setCanScrollRight(state.canScroll.right)
    setCanScrollUp(state.canScroll.up)
    setCanScrollDown(state.canScroll.down)
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>{`Now let's add a cover photo. Which one do you prefer?`}</Heading>
      <div className={styles['choose-profile-bg-wrapper']}>
        <div className={styles['cover-photos-wrapper']}>
          <Overflow className={styles['cover-photos-overflow']} onStateChange={scrollStateChange}>
            <Overflow.Content>
              <div className={styles['cover-photos']}>
                {covers.map((item) => {
                  const selected = item === cover
                  let classnames = styles['cover-photo-wrapper']
                  if (selected) {
                    classnames = `${styles['cover-photo-wrapper']} ${styles['cover-photo-wrapper-selected']}`
                  }

                  return (
                    <div key={item} className={classnames} onClick={() => setCover(item)}>
                      <Image
                        src={`/profilebg/mobile/${item}`}
                        alt={`Cover Image ${item}`}
                        className={styles['cover-photo']}
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                        priority={true}
                        quality="70"
                      />
                      {selected && (
                        <div className={styles['checkmark']}>
                          <Checkmark />
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </Overflow.Content>
          </Overflow>
          {(canScrollLeft || canScrollUp) && (
            <div className={styles['icon-left']}>
              <ChevronLeft />
            </div>
          )}
          {(canScrollRight || canScrollDown) && (
            <div className={styles['icon-right']}>
              <ChevronRight />
            </div>
          )}
        </div>

        <div className={styles['form-footer']}>
          {cover && (
            <div className={styles['cover-submit']}>
              <Button onClick={setCoverAndSubmit} primary centered disabled={isSubmitting} spinner={isSubmitting}>
                Choose This Cover Photo
              </Button>
            </div>
          )}

          <Button onClick={submit} block primary={false} disabled={isSubmitting} spinner={isSubmitting}>
            Skip
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ChooseProfileBg
